import { render } from "./ColorPicker.vue?vue&type=template&id=235069d8"
import script from "./ColorPicker.vue?vue&type=script&lang=js"
export * from "./ColorPicker.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./ColorPicker.vue?vue&type=style&index=0&id=235069d8&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script